import {
	firstTimeCongratsScreenAtom,
	NCOnboardingAnalyticsEvents,
	useNCWOnboardingRoutes
} from '@capsicum/features/nc-onboarding/shared';
import { useMe } from '@capsicum/socios-core';
import { useAtom } from 'jotai';
import { useCallback, useEffect, useState } from 'react';

import { getUserNeedsTravelRule } from '../data-access/api/travelRule';

export const useCanCreateNCW = ({
	isNewUser,
	isRequirementsLoading,
	onDone,
	showVerifyModal
}: {
	isNewUser: boolean;
	isRequirementsLoading: boolean;
	onDone: () => void;
	showVerifyModal: () => void;
}) => {
	const [firstTimeCongratsScreen, setFirstTimeCongratsScreen] = useAtom(firstTimeCongratsScreenAtom);
	const [initalModalTriggered, setInitalModalTriggered] = useState(false);
	const { triggerAnalyticsEvent } = useNCWOnboardingRoutes({});
	const [isLoading, setIsLoading] = useState(false);
	const { me } = useMe();

	const checkIfIsReadyForMigration = useCallback(async () => {
		if (isNewUser) return true;
		if (me.metadata?.needsTravelRule !== undefined) {
			return !me.metadata.needsTravelRule;
		}

		setIsLoading(true);
		const { data: needsTravelRule } = await getUserNeedsTravelRule();

		setIsLoading(false);

		return !needsTravelRule;
	}, [me?.metadata?.needsTravelRule]);

	useEffect(() => {
		if (firstTimeCongratsScreen) {
			triggerAnalyticsEvent(NCOnboardingAnalyticsEvents.LAND_ON_CONGRATULATIONS);
			setFirstTimeCongratsScreen(false);

			return;
		}

		if (isRequirementsLoading) return;
		// After the first time the user gets into the congratulations screen the metadata gets updated
		// and every time he navigates to that screen we should inmediately show the verify modal
		if (!initalModalTriggered && me.metadata?.needsTravelRule) {
			showVerifyModal();
			setInitalModalTriggered(true);
		}
	}, [
		firstTimeCongratsScreen,
		initalModalTriggered,
		isRequirementsLoading,
		me.metadata?.needsTravelRule,
		showVerifyModal,
		triggerAnalyticsEvent
	]);

	const onContinue = async () => {
		const isReadyForMigration = await checkIfIsReadyForMigration();

		if (isReadyForMigration) {
			triggerAnalyticsEvent(NCOnboardingAnalyticsEvents.GO_TO_NCW_FROM_CONGRATULATIONS);
			onDone();
		} else {
			showVerifyModal();
		}
	};

	return {
		checkIfIsReadyForMigration,
		firstTimeCongratsScreen,
		isLoading,
		onContinue
	};
};
